<template>
  <v-container d-flex text-xs-center class="page-content create-group">
    <v-layout row wrap>
      <v-flex xs12>
        <v-content class="mb-5">
          <v-img class="mb-4" :src="illustrationImage" />
          <h2 class="font-weight-black">Create a Group</h2>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </p>
        </v-content>
      </v-flex>

      <v-flex xs12>
        <v-content>
          <MainButton @click.native="routeToCreateGroup" class="mb-4">
            CREATE GROUP
          </MainButton>

          <router-link to="#" class="white--text">SKIP</router-link>
        </v-content>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import MainButton from '@/components/MainButton/index'

export default {
  name: 'CreateGroup',
  components: {
    MainButton
  },
  data: () => ({
    illustrationImage: require('@/assets/illustration.svg')
  }),
  methods: {
    routeToCreateGroup() {
      this.$router.push({ name: 'create-group-invite' })
    }
  }
}
</script>

<style lang="scss">
.create-group {
}
</style>
